import { getDistance } from 'geolib';
import uniq from 'lodash/uniq';
import flatten from 'lodash/flatten';
import lowerCase from 'lodash/lowerCase';
import get from 'lodash/get';
import config from '$config';

const addRoundedMiles = (garage) => {
  garage.collectionRoundedMiles = Math.round(garage.collectionDistanceMiles * 100) / 100;
  garage.deliveryRoundedMiles = Math.round(garage.deliveryDistanceMiles * 100) / 100;
  return garage;
};

// geoLib sensibly returns KM, but we still work in old money here...
const getKilometers = (garage, address) =>
  garage.latitude && garage.longitude
    ? getDistance(
      { latitude: address.latitude, longitude: address.longitude },
      { latitude: garage.latitude, longitude: garage.longitude }
    ) / 1000
    : Infinity;

const getMiles = (km) => km * 0.621371;

export const getTopLocalGarages = (garages, areas, collection, delivery) => {
  const activeGarages = garages.filter((garage) => lowerCase(garage.status) === 'active');

  // Old postcode api response
  const garageIdsInArea =
    get(config, 'zonesApiVersion') === 'new'
      ? areas.map((a) => a.ownerId)
      : uniq(flatten(areas.map((a) => a.garages)));

  return activeGarages
    .map((garage) => {
      garage.collectionDistanceKM = getKilometers(garage, collection);
      garage.deliveryDistanceKM = getKilometers(garage, delivery);
      garage.collectionDistanceMiles = getMiles(garage.collectionDistanceKM);
      garage.deliveryDistanceMiles = getMiles(garage.deliveryDistanceKM);

      if (garageIdsInArea.find((garageId) => garageId === garage.garageId))
        garage.coversBookingLocation = true;

      addRoundedMiles(garage);
      return garage;
    })
    .sort((a, b) => a.collectionDistanceKM - b.collectionDistanceKM)
    .slice(0, 100);
};

export const getGaragesInArea = (garages, areas) => {
  const garageIdsInArea = uniq(flatten(areas.map((a) => a.garages)));
  return garages.filter((garage) => garageIdsInArea.indexOf(garage.garageId) >= 0).map(addRoundedMiles);
};
